import classNames from 'classnames'

import { useUserProgress } from '@shared'
import { useUser } from '@store'

import { ProgressBar } from '../ProgressBar/ProgressBar'
import { UserLevel } from '../UserLevel/UserLevel'
import styles from './UserLevelProgress.module.scss'

type UserLevelProgressProps = {
  className?: string
  onClick?: () => void
}

export const UserLevelProgress = ({
  className,
  onClick,
}: UserLevelProgressProps) => {
  const progress = useUserProgress()
  const { profile } = useUser()

  const level = profile?.battlepassLevel ?? 0

  return (
    <div className={classNames(styles.container, className)} onClick={onClick}>
      <svg className={styles.icon} viewBox="0 0 14 14" fill="none">
        <path
          d="M8.75 5.25C8.75 5.25 7 3.67 7 0C7 3.67 5.25 5.25 5.25 5.25C5.25 5.25 3.67 7 0 7C3.67 7 5.25 8.75 5.25 8.75C5.25 8.75 7 10.33 7 14C7 10.33 8.75 8.75 8.75 8.75C8.75 8.75 10.33 7 14 7C10.33 7 8.75 5.25 8.75 5.25Z"
          fill="white"
        />
      </svg>
      <div className={styles.progressBar}>
        <ProgressBar progress={progress} />
      </div>
      <UserLevel level={level} className={styles.userLevelIcon} />
    </div>
  )
}
